import { registerExperiment } from '@xingternal/splitkit';

export const LEBENSLAUF_EXPERIMENT_NAME = {
  name: 'ABACUS-62',
  trackingId: 'A-62',
  supportedVariants: ['A', 'B'],
  isLoggedOut: true,
};
export const JOBSEEKER_EXPERIMENT_NAME = {
  name: 'ABACUS-95',
  trackingId: 'A-95',
  supportedVariants: ['A', 'B'],
  isLoggedOut: true,
};

const register = () => {
  [LEBENSLAUF_EXPERIMENT_NAME, JOBSEEKER_EXPERIMENT_NAME].forEach(
    ({ name, supportedVariants, isLoggedOut }) => {
      registerExperiment(
        name,
        supportedVariants,
        isLoggedOut ? 'visitor' : undefined
      );
    }
  );
};

export default register;
